// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3_rhN","search":"Settings_search__2ngPv","filter":"Settings_filter__2Odri"};